export const DEFAULT_TIMEZONE_IANA = "America/Detroit";
export const DEFAULT_TIMEZONE_TEXT = "EST";
